export default {
    'Common': {
        'modify_password': '修改密码',
        'logout': '退出',
        'date': '日期',
        'reason': '原因',
        'id': 'ID',
        'yes': '是',
        'no': '否',
        'all_coath': '全部教练',
        'all_place': '全部场地',
        'all_store': '所有门店',
        'all_store2': '全部门店',
        'zidong': '自动生成',
        'store_placeholder': '请选择门店',
        'place_placeholder': '请选择场地',
        'store_tip': '进入门店',
        'store': '门店',
        'client_tip': '搜索客户姓名、电话、会员卡号、卡物理ID，临时储物柜号',
        'client_tip2': '搜索客户姓名、电话、会员卡号、租赁柜号',
        'search': '搜索',
        'clear': '清空',
        'tip': '提示',
        'scan_code': '扫码',
        'click_scan_code': '点击后进行扫码',
        'cancel': '取消',
        'base_info': '基本信息',
        'card_number': '会员卡号',
        'member_card': '会员卡',
        'member_card_number': '会员卡名称',
        'card_number_placeholder': '请输入会员卡号',
        'name': '姓名',
        'name_placeholder': '请输入姓名',
        'phone': '电话',
        'gender': '性别',
        'gender_placeholder': '请选择性别',
        'male': '男',
        'female': '女',
        'birthday': '生日',
        'birthday_placeholder': '请选择生日',
        'phone_number': '手机号',
        'telephone_number': '手机号码',
        'phone_phone': '手机',
        'phone_placeholder': '请输入手机号',
        'wechat': '微信',
        'wechat_placeholder': '请输入微信',
        'number_type': '会员类型',
        'follow_coach': '跟进教练',
        'saler': '会籍销售',
        'cabinet_number': '租赁柜号',
        'locker': '租赁柜',
        'cabinet_time': '租柜有效期',
        'remark': '备注',
        'remark_placeholder': '请填写备注',
        'none_data': '暂无数据',
        'appointment_info': '预约信息',
        'time': '时间',
        'lesson': '课程',
        'coach': '教练',
        'choose_coach': '请选择教练',
        'enter_store': '入场门店',
        'enter_time' : '入场时间',
        'outer_time' : '离场时间',
        'fen_tiem': '分配日期',
        'last_follow_time': '最后跟进日期',
        'last_follow_people': '最后跟进人',
        'choose_date': '请选择日期',
        'choose_date2': '选择日期',
        'search_cha': '查询',
        'leave_time': '离开时间',
        'bind_physical': '绑定会员卡物理ID',
        'click_bind_physical': '请点击此处后把会员卡置于读卡器上',
        'take_phone': '拍照',
        'upload': '上传',
        'distribution_saler': '分配会籍销售',
        'distribution_saler_placeholder': '请选择会籍销售',
        'potential_customer_manage': '潜在客户管理',
        'member_management': '会员管理',
        'membership_to_potentialCustomer': '会籍销售跟进潜在客户',
        'MembershipSales_to_member': '会籍销售跟进会员',
        'Number_sales_follow-up': '销售跟进次数',
        'distribution_coach': '分配教练',
        'follow-up': '跟进',
        'member_side': '会员体测',
        'must_exercise_data': '必确运动数据',
        'delete—in-batches': '批量删除',
        'recover—in-batches': '批量恢复',
        'new_customer': '新增客户',
        'screen': '筛选',
        'prospective_customer': '潜在客户',
        'full_member': '正式会员',
        'add_search': '添加筛选类型',
        'screening_condition': '筛选条件',
        'please_import_id': '请输入会籍销售员工 id',
        'member_status': '会员状态',
        'please_import_staffID': '请输入录入员工 id',
        'select_customer_classify': '请选择客户分类',
        'select_customer_label': '请选择客户标签',
        'age': '年龄',
        'marital_status': '请选择婚姻状况',
        'sons_and_daughters': '请选择子女情况',
        'consult_approach': '请选择获取咨询途径',
        'personal_preference': '请选择个人爱好',
        'picture': '是否有照片',
        'Along_with_city': '请输入俱乐部品牌',
        'employee_message': '员工工号、姓名、昵称、手机号',
        'followup_record': '跟进记录',
        'Membership_staffID': '会籍销售员工 ID',
        'entering_employeeID': '录入人员工 ID',
        'marrystatus': '婚姻状况',
        'get_info_way': '获取资讯途径',
        'Along_with_the_city': '俱乐部品牌',
        'Former_member_club': '曾是本俱乐部会员',
        'name_phone_card': '客户姓名、手机号、会员卡号',
        'message': {
            'selectclientmsg': '至少选择一条客户信息',
            'affirmdelmsg': '确认删除这些客户信息?',
            'canceldel': '已取消删除',
            'restoreclientmsg': '确认恢复这些客户信息?',
            'successRestore': '恢复成功',
            'cancelRestore': '已取消恢复',
            'Pleaseselectone': '请至少选择一条记录～',
            'onlyoperationone': '您只能对一条数据进行操作～',
            'Pleaseselectonetodo': '请选择一条数据进行操作～',
        },
        'please_choose': '请选择',
        'close': '关闭',
        'save': '保存',
        'data_not_found': '未找到数据',
        'all_saler': '全部会籍销售',
        'choose_one': '请先选择一条记录',
        'submit': '提交',
        'start_time': '开始日期',
        'end_time': '结束日期',
        'minute': '分钟',
        'use_con': '使用合同',
        'position': '位置号',
        'operating': '操作',
        'sign': '签到',
        'all_coach': '所有教练',
        'number': '编号',
        'next_step': '下一步',
        'prev_step': '上一步',
        'carry_out': '完成',
        'all_type': '全部类型',
        'total': '总计',
        'fill_password': '请输入登录密码',
    },
    'tooltip': {
        'add': '添加',
        'edit': '编辑',
        'delete': '删除',
        'export': '导出',
        'import': '导入',
        'check': '查看',
        'refresh': '恢复',
        'setting': '设置',
        'system': '系统公告',
        'message': '消息',
        'back_list': '返回门店列表',
        'new_place': '新增门店场地',
        'back': '返回',
    },
    'Message': {
        'tip_code_sign': '请向用户获取验证码以确认签到！',
        'tip_title': '提示信息',
        'no_permission': '您无权访问此页面，请返回',
        'confirm': '确定',
        'success': '操作成功',
        'return_success': '归还成功~~',
        'admission_info': '入场凭证(会员卡或者全民健身活动领取的卡)～～',
        'temporary_whether': '是否归还临时储物柜',
        'save': '保存成功！',
        'delete_success': '删除成功',
        'tip_one': '请先选择一条记录！',
        'copy_success': '复制成功！',
        'sign_tip': '确认签到？',
        'sign_success': '签到完成!!',
        'cancel_confirm': '确认取消预约？',
        'cancel_success': '取消预约成功!!',
        'cancel_freeze': '您确定要解除冻结吗？',
        'choose_contract': '请选择一个合同！',
        'choose_once': '请至少选择一条数据～',
        'once_data': '您只能选择一条数据～',
        'choose_one': '请先选择一条记录！',
        'one_data': '您只能选择一条记录！',
        'export_confirm': `您是否确定开始导出报表？点击“确定”，
        即可立即查看导出详情记录~若您未选择时间，则默认导出当前一个月的数据`,
        'brand_logo': '请上传品牌logo',
        'info_one': '您只能选择一条信息～',
        'plase_one_info': '请先选择一条信息～',
        'member_recode': '您只能选择一条会员记录~~',
        'member_recode_choose': '请先选择一条会员记录~~',
        'enter_tip': '只有潜在会员才可以入会',
        'xu_tip': '所选客户不是正式会员',
        'pay_success': '支付成功 ~ ~',
        'tong_count': '请输入正确的最大通店数不小于1 ~ ~',
        'add_success': '新增成功～',
        'edit_success': '编辑成功～',
        'empty_content': '内容不能为空',
        'send_success': '发送成功',
        'newsList': '消息列表',
        'repeat_saler': '分配了重复的销售，请检查',
        'refersh': '修改任务提交成功，请等待并刷新页面更新~~',
        'ci_modify': '仅能对次卡进行修改~~',
        'count_tip': '请输入符合规范的操作数量~~',
        'coach_success': '修改上课教练成功~~',
        'setting_price': '价格设定成功!!',
        'error': '错误提示',
        'sorry_no_authority': '对不起！您暂无此权限',
        'please_admin': '请联系管理员为您开通',
        'Select_A_Coach': '请先选择一个教练～',
        'choose_member_for_sale ': '请先选择一个会籍销售～',
        'Please_select_a_data': '请先选择一条数据～',
        'Minimum_scaling58%': '此类合同最小缩放为58%',
        'confirm_mershipcard': '确认恢复这个会籍卡?',
        'Member_card_number_noempty': '会员卡号不能为空',
        'choose_your_store': '请选择所属门店',
        'Confirm_discard': '确认废弃这个卡号?',
        'Discarded_success': '废弃成功',
        'Cancelled': '已取消',
        'Confirm_to_restore': '确认恢复这个卡号?',
        'Confirm_the_ban': '确认禁售这个会籍卡?',
        'Successful_sale_ban': '禁售成功',
        'select_customer_label': '请选择想要编辑的客户标签',
        'select_customer_del': '请选择想要删除的客户标签信息',
        'Alltags_del': '客户信息里所有此标签将会被同步删除,',
        'Unable_to_recover': '无法恢复，确认删除此标签？',
        'customer_label_information_restore': '请选择想要恢复的客户标签信息',
        'after_restore': '恢复后此标签可再次添加给客户，但之前有此标签的',
        'will_not_restore': '客户将不会恢复此标签，确认恢复此标签？',
        'selecenews': '请选择消息!',
        'Send_notice': '发送公告',
        'confirmdel': '确认删除这条门店信息?',
        'confirmrecord': '确认恢复这个门店?',
        'success_sign': '签到成功',
        'canceldo': '取消操作',
        'Determine_cancel_course': '确定取消课程预约?',
        'not_have_right_cancel': '您没有取消私教预约的权限~~',
        'Are_delete_this_data': '确定要删除此条数据？',
        'del_succ': '删除成功!',
        'GiftSuccess': '赠送成功~~',
        'Successful_revision': '修改成功!',
        'stop_follow': '确定暂停跟进该客户？',
        'keep_follow': '确定继续跟进该客户？',
    },
    'Board': {
        'Flow': {
            'title': '客流',
            'all': '近30天日均客流',
            'make_of_private': '私教：预约人数',
            'subscribeNumver': '预约节数',
            'signinNumber': '签到节数',
            'coachNumber': '上课教练数',
            'League_of_classnumber': '团课：上课节数',
            'entrance_people': '入场人数',
            'Personaltainer': '私教',
            'headcount': '总人数',
            'coach_lesson': '教练上课',
            'select_the_coaches': '请选择分配给的教练',
        },
        'Appointment': {
            'title': '预约到访',
            'no': '未到访',
            'all': '总预约',
            'none': '暂无未到访客',
            'potential': '潜在',
            'formal': '正式',
        },
        'Team': {
            'title': '团课课表',
            'no': '未上课',
            'all': '总排课',
            'none': '暂无团课',
            'todo': '未开始',
            'doing': '进行中',
            'festival': '节',
        },
        'Personal': {
            'title': '私教预约',
            'all': '总预约',
            'none': '暂无私教预约',
            'sign': '未签到',
            'signed': '已签到',
        },
    },
    'Reception': {
        'First': {
            'title': '会员出入场登记',
            'temporary': '临时储物柜号',
            'temporary_placeholder': '请输入临时储物柜号',
            'temporary_locker': '临时储物柜',
            'sign': '入场',
            'out': '离场',
            'consultant': '会籍顾问',
            'picture': '会员照',
            'info': '会籍信息',
            'choose': '入场卡选择',
            'card_name': '卡名称',
            'validity': '有效期',
            'remaining': '剩余',
            'support_store': '支持入场门店',
            'enter_time': '入场时段',
            'frequency' :'本次入场扣除次数',
            'enter_info': '入场信息',
            'choose_member': '请先选择一个会员~~',
        },
        'Second': {
            'title': '前台来访/预约登记',
            'search_placeholder': '搜索客户姓名、电话、会员卡号',
            'linshi': '临时到访',
            'day': '保护天数',
            'day_num': '天数',
            'jie_people': '接待人',
            'jie_people_placeholder': '请选择接待人',
            'linshi_appoint': '临时补约',
            'appoint_search': '预约查询',
            'appoint_status': '请选择预约状态',
            'appoint_saler': '预约会籍销售',
            'appoint_time': '预约时间',
            'appoint_lesson': '预约团课',
            'jie_time': '接待时间',
            'jie_saler': '接待会籍销售',
            'client_out': '客户离场',
            'cancel_appoint': '取消预约',
            'tips': '请选择要添加为临时到访的客户！',
        },
        'Third': {
            'title': '储物柜存取记录',
            'type': '操作类型',
            'type1': '柜子类型',
            'store': '柜子门店',
            'area': '柜子区域',
            'time': '操作时间',
            'zhi': '至',
            'time_placeholder': '请选择年月日',
            'people': '操作人',
            'type3': '柜类型',
            'number': '柜号',
            'desc': '操作详情',
            'option1': '存件开柜',
            'option2': '临时取件',
            'option3': '离场清柜',
            'option4': '入场',
            'option5': '场馆清柜',
            'option6': '取件开柜',
            'option7': '离场',
            'option8': '场馆开锁',
            'option9': '手动修改',
            'option_type1': '临时',
            'option_type2': '租赁',
        },
        'Fourth': {
            'title': '临时储物柜管理',
            'area': '区域信息',
            'small_title': '临时储物柜信息',
            'area1': '区域',
            'letter': '字母',
            'number': '临时储物柜号',
            'status': '状态',
            'name': '使用者姓名',
            'phone': '使用者电话',
            'new_area': '新增区域',
            'area_name': '区域名称',
            'area_name_placeholder': '请输入区域名称',
            'choose_area_place': '请选择区域',
            'shou': '首字母',
            'shou_placeholder': '请输入首字母',
            'start': '起始编号',
            'start_placeholder': '请输入起始编号',
            'count': '数量',
            'count_placeholder': '请输入数量',
            'di': '递增值',
            'di_placeholder': '请输入递增值',
            'delete_confirm': '确定要删除所选的临时储物柜？',
        },
        'Fifth': {
            'title': '租赁柜管理',
            'small_title': '租赁柜信息',
            'number': '租赁柜编号',
            'price': '价格',
            'price_placeholder': '请输入价格',
            'fee': '手续费',
            'sale_status': '销售状态',
            'phy_status': '物理状态',
            'bind': '绑定柜组',
            'wei_bind': '未绑定',
            'end_time': '起止时间',
            'transfer': '转让手续费',
            'transfer_placeholder': '请输入转让手续费',
            'bai': '百分比',
            'bai_placeholder': '请输入百分比',
            'amt': '固定金额',
            'amt_placeholder': '请输入固定值',
            'yuan': '元',
            'change_status': '临时储物柜状态变更',
            'tem_status': '临时储物柜状态',
            'status': '目前状态',
            'change_status2': '更改状态',
            'choose_status': '请选择状态',
            'name_phone': '使用者姓名（手机）',
            'place_name_phone': '请输入姓名或手机号搜索',
            'option1': '闲置',
            'option2': '使用中',
            'option3': '维修',
            'option4': '损坏',
            'option5': '挂失',
            'option6': '解挂',
            'fill_in_info': '请填写使用者信息',
            'edit_sell_cabinet': '租赁柜状态变更',
            'wei_ding': '未定',
            'yi_ding': '已定',
            'normal': '正常',
            'service': '维修',
            'scrapped': '报废',
            'pass': '过期（待清理）',
            'dialog_delete': '确认删除此区域？',
            'delete_confirm': '确定要删除所选的租赁柜？',
        },
        'Sixth': {
            'title': '入场查询',
            'search': '搜索姓名、电话、会员卡号、临时储物柜号',
            'enter_time': '进场时间',
            'all_status': '临时储物柜全部状态',
            'enter_type': '全部入场类型',
            'res': '本次搜索结果',
            'has_card': '入场持卡',
            'type': '入场类型',
            'kou': '扣除次数',
            'inside': '在场时间',
        },
    },
    'Client': {
        'Add': {
            'edit': '编辑客户',
            'new': '新建客户',
            'attributes': '渠道属性',
            'attributes_placeholder': '请选择渠道属性',
            'get_attributes': '获取渠道',
            'get_attributes_placeholder': '请选择获取渠道',
            'follow_level': '跟进等级',
            'follow_level_placeholder': '请选择跟进等级',
            'channel_area': '渠道地区',
            'province_placeholder': '请选择省',
            'city_placeholder': '请选择市',
            'district_placeholder': '请选择区',
            'certificate_type': '证件类型',
            'certificate_type_placeholder': '请选择证件类型',
            'certificate_number': '证件号码',
            'certificate_number_placeholder': '请输入证件号码',
            'Country_of_Citizenship': '国籍',
            'Country_of_Citizenship_placeholder': '国籍',
            'nation': '民族',
            'nation_placeholder': '请选择民族',
            'career': '职业',
            'career_placeholder': '请输入职业',
            'email_placeholder': '请输入E-mail',
            'family_address': '家庭地址',
            'address_placeholder': '请输入详细地址',
            'company_name': '公司名称',
            'company_name_placeholder': '请输入公司名称',
            'company_phone': '公司电话',
            'company_phone_placeholder': '请输入公司电话',
            'work_address': '工作地址',
            'emergency_contact': '紧急联系人',
            'emergency_contact_placeholder': '请输入紧急联系人',
            'contact_people': '联系人电话',
            'contact_people_placeholder': '请输入联系人电话',
            'purpose': '健身目的',
            'purpose_placeholder': '请选择健身目的',
            'club': '是否参加过俱乐部',
            'member_is': '是否曾是本俱乐部会员',
            'brand': '品牌',
            'brand_name': '品牌名称',
            'brand_placeholder': '请输入品牌名称',
            'brand_logo': '品牌Logo',
            'brand_desc': '品牌介绍',
            'brand_image': '品牌图片',
            'leave_reason': '离开原因',
            'leave_reason_placeholder': '请选择离开原因',
            'customer_type': '客户分类',
            'marital_status': '婚姻情况',
            'get_information_habits': '获取资讯习惯',
            'child_situation': '子女情况',
            'personal_hobby': '个人爱好',
            'customer_label': '客户标签',
            'add_success': '新增客户成功',
            'edit_success': '编辑客户成功',
            'status': '客户状态',
            'referrer': '推荐人',
            'add_client': '新增客户',
            'add_lesson_num': '收费课程上课数',
        },
        'title': {
            'member_funnel': '会员漏斗',
            'membership': '会籍漏斗',
            'private_funnel': '私教漏斗',
            'memberattr': '会员属性',
            'membershipcond': '会籍情况',
            'membershipsex': '会籍性别',
            'distributeage': '分布年龄',
            'buyprivprop': '购买私教比例（有效正式会员）',
            'gainditch': '获取渠道',
            'cons_seniority': '星座排行',
            'buypersonprop': '购买私教比例',
        },
        'data': {
            'Hresidue_priv_lesson': '有剩余私教课',
            'Nresidue_priv_lesson': '无剩余私教课',
            'dresidue_priv_lesson': '未购买私教课',
            'valid_official_member': '有效正式会员',
            'past_official_member': '过期正式会员',
            'latent_member': '潜在客户',
            'under_eighteen': '18岁以下',
            'eighteen_among_twentyfour': '18~24岁',
            'twentyfive_among_thirty': '25~30岁',
            'thirtyone_among_forty': '41~50岁',
            'Countries_among_sixty': '51~60岁',
            'above_sixty-first': '61岁以上',
        },
        'Measure': {
            'title': '会员体测',
            'data': '体测数据',
            'weight': '体重',
            'physicaltime': '请选择体测时间',
        },
        'Member': '会员',
        'Paymentratio': '付费占比',
        'select_memberships_sales': '请选择分配给的会籍销售',
        'MembershipSalesID': '会籍销售ID',
        'name_tobeassigned': '名，要分配给',
        'Currentsales': '当前销售',
        'SelectedPotentCustomers': '已选潜在客户',
        'type': '客户类型',
        'follow_remark': '跟进备注',
        'communication_result': '通讯结果',
        'entry_date': '录入日期',
        'old_card_number': '原会员卡号',
        'bind_new_psy': '绑定新会员卡物理ID',
        'click_duka': '点击此处后将会员卡置于读卡器上',
        'club': '会所',
        'phy_id': '会籍卡物理ID',
        'address': '地址',
        'transact_club': '办理入会',
        'continuation_again': '再次续会',
        'buyprivate': '购买私教',
        'rebuyprivate': '复购私教',
        'latelyweek': '近一周',
        'latelyonemonth': '近一个月',
        'latelythrmonth': '近三个月',
        'latelysixmonth': '近六个月',
        'three': '三体线上获客',
        'people': '人',
        'indent': '总成单数',
        'order_amount': '总成单金额',
        'tip': '注：',
        'tip1': '1. 转店后将修改合同签约门店，请在私教合同列表中及时更换上课教练',
        'tip2': '2. 转店后合同支付会同步替换',
        'allclient': '全部客户',
        'allflowup': '全部跟进人',
        'flowup_starttime': '请选择跟进开始时间',
        'flowup_Endtime': '请选择跟进结束时间',
        'record': '条记录',
        'flowup_type': '跟进类型',
        'Customer': '客户',
        'after_flowup_Num': '入会后跟进次数',
        'AdmissionTime': '入会时间',
        'last_training': '最后一次训练至今天数',
    },
    'Course': {
        'Appoint': {
            'frequency': '本次预约节数',
            'fill_fre': '请输入预约节数',
            'card_name': '储值卡名',
            'buy': '已购',
            'amt': '金额',
            'frequency2': '节数',
            'time': '单课时长',
            'end_time': '课程截止日期',
            'appoint_ci': '预约节数',
            'time_coach': '选择时间及上课教练',
            'time_coach2': '请选择时间及上课教练',
            'no_set': '工作时间未设置',
            'no_store_coach': '已非此门店私教教练',
            'choose_ci': '请填写符合规范的预约节数~~',
        },
        'Coach': {
            'remaining_sections': '剩余节数',
            'change_time': '修改课时',
        },
        'add_personal': '添加私教课程',
        'edit_personal': '编辑私教课程',
        'fist_title': '团课课表',
        'second_title': '团课课程设置',
        'third_title': '私教预约表',
        'fourth_title': '私教课程设置',
        'fifth_title': '私教教练工作时间设置',
        'index_message': '您是否确定开始导出报表？点击“确定”，即可立即查看导出详情记录~',
        'copy_course': '课程批量复制',
        'jiang': '将',
        'copy1': '的团课复制到',
        'copy_button': '复制',
        'lesson_time': '开课时间',
        'pay': '付费',
        'about': '约',
        'limi': '不限',
        'to': '到',
        'none': '本周暂无团课课时',
        'no_promission': '您无权限查看课表',
        'back': '返回团课列表',
        'add': '添加团课预约',
        'name': '课程名称',
        'area': '上课地点',
        'coach': '上课教练',
        'coachId': '教练ID',
        'allot': '分配',
        'time': '上课时间',
        'ke_count': '可预约人数',
        'yi_count': '已预约人数',
        'sign_count': '会员签到人数',
        'choose_one': '请选择一个课时!!',
        'delete': '确定删除选中课时吗？',
        'delete_success': '删除课时成功！',
        'tip1': '是否将',
        'tip2': '的全部课程，复制至',
        'copy_confirm': '课程复制确认',
        'tip_confirm': '确定复制',
        'sign_permission': '您没有签到团课的权限~~',
        'cancel_permission': '您没有取消团课预约的权限~~',
        'check_all': '全选',
        'image': '课程图片',
        'appoint_coach': '可预约的上课教练',
        'pay_anthor': '是否预约另付费',
        'introduction': '课程介绍',
        'add_course': '添加团课课程',
        'choose_store': '请至少选择一个门店',
        'choose_pay_anthor': '请选择是否预约付费',
        'edit': '编辑团课课程',
        'appoint_status': '预约状态',
        'true_caoch': '实际上课教练',
        'name2': '课程名',
        'course_type': '课程类型',
        'class_number': '本次上课数',
        'personal_lesson': '私教课',
        'personal_price': '私教课程价格设定',
        'pay_group_course': '付费团课',
        'single_pay_personal': '单次购买私教课程',
        'Make_an_appointment': '预约后剩余课时',
        'Single_class_value': '单课价值',
        'Appointments': '预约人',
        'sign_time': '签到时间',
        'sign_person': '签到人',
        'Recent_admission': '最近入场',
        'sign_in_for_course': '确定课程签到?',
        'CoursePriceLevel': '课程价格级别',
        'release_time': '发布时间',
        'Selfless_teach_no': '无私教课程存在！',
        'choose_price': '请先选择一个价格设置!!',
        'not_support_single': '此课程不支持储值卡单次购买，请先进行课程编辑设置~~',
        'delete_ok': '确定删除？',
        'non_rep': '此设定已删除！！不要重复删除！！',
        'Set_date': '设定日期',
        'copy': '的私教课程可预约时间复制到↓↓↓',
        'ReservTimeSett': '可预约时间设定',
        'ReservTime': '可预约时间',
        'Temporary_leave': '临时请假',
        'starttime': '开始时间',
        'Endtime': '结束时间',
        'coach_can_private': '该教练可上私教课程',
        'coach_no_privte': '该教练无可上私教课程',
        'confirm_delthis': '确认删除该条时间记录？',
    },
    'Week': {
        'Selectdate': '选择日期时间',
        'month': '月',
        'day': '日',
        'mon': '星期一',
        'tues': '星期二',
        'wed': '星期三',
        'thur': '星期四',
        'fri': '星期五',
        'satu': '星期六',
        'sun': '星期日',
        'time': '时长',
        'refresh_time': '最近更新时间：实时',
        'refresh_time2': '最近更新时间',
        'day2': '天',
        'hour': '小时',
        'second': '秒',
        'ci': '次',
        'if': '若',
        'extension': '延期',
        'lease_period': '租期(月)',
        'lease_period2': '租期',
        'fill_lease_period': '请填写租期(月)',
        'fill_lease_period2': '请填写租期',
        'entry_time': '录入时间',
        'monday': '周一',
        'Tuesday': '周二',
        'wednesday': '周三',
        'thursday': '周四',
        'friday': '周五',
        'saturday': '周六',
        'sunday': '周日',
    },
    'Lesson': {
        'FreeCourses': '免费课程上课数',
        'time_of_feebased': '收费课程购买时间',
        'CompletionTime': '收费课程上完时间',
        'Appointment_course': '预约课程',
        'Appointment_class': '预约课时',
        'Appointmentcoach': '预约教练',
        'FreeCourseReserva': '免费课程预约',
        'PurchasedCourseReservat': '已购买课程预约',
        'store': '上课门店',
        'place': '上课场地',
        'count': '上课人数',
        'limi': '不限制',
        'appoint_count': '预约人数',
        'success': '修改课时成功!!',
        'add_appoint': '添加团课预约',
        'choose_store': '请选择上课门店',
        'choose_place': '请选择上课场地！',
        'add': '添加课程',
        'choose_time': '请选择上课时间！',
        'appoint_pay': '预约付费',
        'pay_setting': '付费设置',
        'deleted': '已删除',
        'pay_course_setting': '付费团课设置',
        'anthor': '是否预约另外付费',
        'anthor_card': '是否支持储值卡单次购买',
        'anthor_card2': '是否支持储值卡单次购买：支持',
        'choose_set': '选择可预约储值卡并设置预约扣费价格',
        'time': '课程时间',
        'dai': '代预约私教课程',
        'edit_coach': '编辑上课教练',
        'sign': '课程签到',
        'canale_appoint': '取消课程预约',
        'small_print': '打印小票',
        'all_lesson': '所有课程',
        'once_buy': '私教单次购买设置',
        'count_to': '数量区间',
        'money': '元/节',
        'lesson': {
            'classGrade': '课程名称(级别)',
            'residueClass': '剩余课程额度',
            'organizationClass': '团体课上课',
            'Name_of_Private_class': '私教课程名称',
            'Class_coach_name': '上课教练昵称',
            'residue_class': '剩余节数',
            'integration': '积分',
            'integration_recordID': '积分记录ID',
            'integrationNumber': '积分数',
        },
        'wei_guoqi': '未过期剩余课数',
        'yi_guoqi': '已过期剩余课数',
        'personal': '私教课程',
        'purchased_times': '已购次数',
        'remaining_times': '剩余次数',
        'purchased_class': '已购课时',
        'remaining_class': '剩余课时',
        'increase': '增加',
        'cut_back': '减少',
        'frequency': '次数',
        'class': '课时',
        'choosethepurpose': '请选择通讯目的！',
        'facesucc': '见面成功',
        'faceerr': '见面失败',
        'noreply': '未回复',
        'replied': '已回复',
        'senderr': '发送失败',
        'Opinions_on_coach': '对教练有意见',
        'Opinions_on_League': '对团课有意见',
        'Opinions_on_service': '对服务有意见',
        'Opinions_on_Club': '对俱乐部硬件有意见',
        'Uninterested': '不感兴趣',
        'Notime': '最近没时间',
        'Greetingphone': '问候电话',
        'halt': '停机',
        'cut': '挂断',
        'shutdown': '关机',
        'vacantnumber': '空号',
        'busy': '电话忙',
        'connect': '接通',
        'noanswer': '无人接听',
        'contents_of_call': '请填写通话内容',
        'failurereason': '请选择未成功原因！',
        'communication_result': '请选择通讯结果！',
        'select_follower': '请选择跟进人',
        'Nextcontacttime': '下次联系时间',
        'Callcontent': '通话内容',
        'mership_began': '会籍合同有效期未开始也可进入且可约团课和已购买的合同未开始的私教课',
        'nofirst_entry_card': '若未第一次入场开卡合同，入场后也不会开卡',
        'membership_subcards': '会籍次卡不扣次数',
        'PrivateTeaching': '私教课扣课程次数',
    },
    'Member': {
        'Follow': {
            'choose_status': '请选择通讯状态！',
            'enter_system': '前录入系统',
            'base_info': '客户信息',
            'Reservationtype': '预约类型',
            'people': '跟进人',
            'add': '添加跟进记录',
            'id': '跟进记录ID',
            'has_group': '团体课上课',
            'integral': '积分',
            'sms': '短信',
            'record': '分配记录',
            'record_id': '分配记录ID',
            'record_type': '记录类型',
            'record_remark': '记录备注',
            'record_staff': '跟进员工ID',
            'record_staff_name': '跟进员工昵称',
            'course_name': '课程名称(级别)',
            'course_quota': '剩余课程额度',
            'cards_name': '储值卡卡种名称',
            'cards_id': '储值卡ID',
            'amt': '储值卡充值金额',
            'serial_number': '序号',
            'temporary_locker': '临时储物柜',
            'appoint_methods': '预约方式',
            'personal_name': '私教课程名称',
            'coach_nickname': '上课教练昵称',
            'integral_id': '积分记录ID',
            'integral_number': '积分数',
            'sms_id': '短信记录ID',
            'send_time': '发送时间',
            'send_content': '发送内容',
            'operat_staff': '操作员工',
            'operat_staff_id': '操作员工ID',
            'time': '跟进时间',
            'saler_status': '会籍销售跟进状态',
            'last_time': '会籍销售最后跟进时间',
            'coach_status': '教练跟进状态',
            'coach_last_time': '教练最后跟进时间',
            'coach_ci': '教练跟进次数',
            'last_date': '最后跟进时间',
            'Last_follow-up': '最后跟进',
            'table_coach_status': '跟进状态',
            'appoint_team_coach': '预约团课教练',
        },
        'Service': {
            'methods': '服务方式',
            'phone': '电话跟进',
            'sms': '信函/短信跟进',
            'face': '见面跟进',
            'email': 'Email跟进',
            'purpose': '通讯目的',
            'saler': '销售跟进',
            'ti': 'TI回电',
            'fee_coach': '免费课联系',
            'body': '体测',
            'status': '通讯状态',
            'appoint_fail': '未预约成功',
            'fail_reason': '未成功原因',
        },
        'Distribution': {
            'saler': '分配前会籍销售员工',
            'saler_after': '分配后会籍销售员工',
            'coach': '分配前教练员工',
            'coach_after': '分配后教练员工',
            'staff': '分配员工',
            'time': '分配时间',
        },
        'Desc': {
            'time': '正式成为会员时间',
            'entry': '录入人',
            'message': '发送短信',
            'message_tip': '短信签名计入短信字数，67个字符算一个短信',
            'message_tip2': '注：受短信运营商限制，每日22:00到第二天8:00不可发送短信。',
            'transfer_store': '会员合同转店',
            'choose_transfer': '选择需要转店的合同',
            'transfer_to': '转店至',
            'transfer_fee': '转店手续费',
            'fill_fee': '请输入转店手续费',
            'fee_store': '手续费归属门店',
            'search': '搜索会员',
        },
        'revenueflow': {
            'staymoney': '待付金额',
            'thisflow': '本次流水',
            'Cashier': '收银人',
            'pri_contract': '私教合同',
            'valuecard_contract': '储值卡合同',
            'cash_contract': '押金合同',
            'new_do': '新办',
            'conti_do': '续办',
            'reimburse': '退款-仅退款',
            'termination': '退款-客户要求终止合同',
            'again': '退款-信息录错重办',
            'balancing': '平账',
            'earnest': '定金',
            'new_cashpledge': '新办押金',
            'return_cashpledge': '退还押金',
            'payable_instalments': '分期支付',
        },
        'Reserved_conta_ttime': '预定联系时间',
        'Final_followup': '最后跟进距现在天数',
        'phone_flowup': '电话跟进次数',
        'Days_of_expiration': '会籍过期天数',
        'end': '会员截止日期',
        'search': '搜索客户姓名、手机号、会员卡号',
        'name': '会员名',
        'name2': '会员姓名',
        'telephone': '会员电话',
        'add': '入会',
        'xu': '续会',
        'add_personal': '买私教',
        'add_card': '买储值卡',
        'add_locker': '添加租柜',
        'up_money': '增加定金金额',
        'yan': '定金延期',
        'has_zhong': '拥有卡种',
        'start_end_date': '会籍起止日期',
        'check_has': '查看已购买的',
        'personal_contract': '个私教合同',
        'open_card_store': '开卡门店',
        'xu_store': '续会门店',
        'sign_store': '签约门店',
        'saler': '销售人员',
        'saler2': '销售人',
        'price_level': '价格级别',
        'buy_count': '购买数量',
        'open_card_method': '开卡方式',
        'open_card_placeholder': '请选择开卡方式',
        'admission_contract': '入会合同',
        'renewal_contract': '续会合同',
        'membership': '会籍',
        'enter_date': '入会日期',
        'transfer_store': '转店',
        'Send': '发短信',
        'Time': {
            'end': '会籍截止日期',
        },
        'bu': '会员补卡',
        'if': '是否仅正式会员可买',
        'if_experience': '是否为体验卡',
        'is_experience': '是（潜在客户每人只能购买一次）',
        'member': '会员',
        'member_psyid': '会员卡物理ID',
    },
    'Card': {
        'cant_pay': '没有可扣费的储值卡',
        'choose_pay': '选择预约扣费储值卡',
        'amt': '余额',
        'pay': '本次预约扣费',
        'please_choose': '请选择要扣费的储值卡~~',
        'appoint_success': '预约成功',
        'Member_booking': '会籍预约',
        'LeagueBooking': '团课预约',
        'ps': '注：最大可预约人数若不填写则为不限人数',
        'card1': '储值卡',
        'card2': '会籍卡',
        'pay_one': '预约一次扣费(元)',
        'setting_price': '批量设置价格',
        'all_type': '所有卡类型',
        'type': '卡类型',
        'all_zhong': '所有卡种',
        'image': '卡图片',
        'id': '卡ID',
        'add_time': '卡添加时间',
        'phy_id': '物理ID',
        'holder': '持有人',
        'holder_phone': '持有人电话',
        'bind_time': '最近绑定时间',
        'edit_member_card': '编辑会员卡号',
        'add_member_card': '添加会员卡号',
        'client_id': '客户ID',
        'client_name': '客户姓名',
        'service': '卡服务',
        'CardType': '卡种',
        'Way': {
            'day': '当天买卡当天开卡',
            'enter': '第一次入场开卡',
            'date': '指定日期开卡',
        },
        'gift': '赠送次数',
        'gift_day2': '赠送天数',
        'edit': '编辑卡',
        'add': '新增',
        'stop_date': '停卡日期',
        'automatic_open': '天未入场则自动开卡',
        'last_automatic': '最迟自动开卡日期',
        'secondary_card_type': '次卡类型',
        'term_type': '期限类型',
        'effective_number': '有效次数',
        'effective_day': '有效天数',
        'gift_time': '购买时可赠送次数',
        'gift_day': '购买时可赠送天数',
        'actual_value': '实际价值',
        'sell_base_amt': '售卖基础价格',
        'single_store': '单店,仅开卡门店',
        'cardName': '储值卡卡种名称',
        'cardRecharge': '储值卡充值金额',
        'Is_experience_card': '是否为体验卡',
    },
    'Alert': {
        'course_tip': '该卡不支持付费团课设置，请先进行卡编辑设置~~',
        'course_tip2': '删除课程后，会员将无法继续预约该课程~',
        'course_tip3': '确定删除该课程？',
        'course_refresh': '确定恢复课程?',
        'choose_one': '至少选择一个合同，温馨提示：请操作全选或者某个表格中的选择框',
        'choose_setting': '该卡不支持单次购买私教设置，请先进行卡编辑设置~~',
        'not_have_the_right': '您没有签到私教的权限~~',
    },
    'Fill': {
        'Bank': {
            'city': '请输入城市',
            'qu': '请输入市区',
            'bank': '请选择银行',
            'name': '请输入银行支行名称',
            'open': '请输入银行开户名',
            'account': '请输入银行账号',
        },
        'acount_rang': '请输入数量区间',
        'sell_price': '请输入常规售价',
        'course_name': '请输入课程名称',
        'course_time': '课程时长',
        'course_fill_time': '请输入时长,单位分钟',
        'course_store': '可排课门店',
        'course_introduction': '请输入课程介绍,限2000字',
        'remark_placeholder': '该备注仅工作人员可见，限500字',
        'new_number_placeholder': '新合同编号不能为空',
        'inside_remark_placeholder': '对内备注不能为空',
        'buy_count_placeholder': '请填写购买数量',
        'cabinet_search': '请输入租赁柜号搜索',
        'card_number': '请填写会员卡号',
        'remark': '请填写操作备注',
        'day': '请输入有效期天数',
        'identity_number_placeholder': '请输入身份证号',
        'card_name': '请输入卡名称',
        'freeze_fee': '请输入冻结收取手续费金额',
        'nickname': '请填写昵称',
        'login_count': '请输入登录账号',
        'password': '请输入登录账号密码',
        'no_password': '此项不填默认不修改密码',
        'actual_name': '请输入真实姓名',
        'charge_amt': '请输入定金金额',
        'extension': '请输入延期天数',
        'search_client': '请输入姓名、手机号进行搜索',
        'base_amt': '请输入基础价格',
        'sell_base_amt': '请填写基础售卖价格',
        'actual_value': '请填写实际价值',
        'sell_start_time': '请填写售卖开始时间',
        'Start_time_sell': '售卖开始时间',
        'sell_end_time': '请填写售卖结束时间',
        'SaleEndTime': '售卖结束时间',
        'validity_period': '请输入有效期',
        'transfer_fee': '请填写转让手续费',
        'discounted_price': '请输入优惠金额',
        'amount_receivable': '请输入应收金额',
        'amount_tips': '应交差价，例如：月卡400，升级为季卡1000，此处应填写600。',
        'message_content': '请输入短信内容',
        'image_code': '请输入图形验证码',
        'start_end_time': '起始时间/结束时间不能为空～',
        'fill_remark': '请输入备注',
        'amt': '请输入金额',
        'new_card': '请输入新卡号',
        'fill_fee': '请输入手续费',
        'charge_money': '请输入有效的押金金额 ~ ~',
        'custom_coefficient': '请输入自定义系数',
        'paid': '支付金额不能为空',
        'paid_type': '支付金额须为数字值',
        'send_message': '请输入短信内容【寰图健身工房】',
        'code': '请输入验证码',
        'fee': '请输入符合要求的手续费金额',
    },
    'Choose': {
        'contract_type': '请选择合同类型',
        'type': '请选择类型',
        'saler': '请选择销售人',
        'saler2': '请选择销售人员',
        'card_type': '请选择卡类型',
        'sell_store': '请选择售卖门店',
        'sell_store2': '请选择可售卖门店',
        'price_level': '请选择价格级别',
        'support_store': '请选择支持门店',
        'card_zhong': '请选择卡种ID',
        'transfer_type': '请选择转让类型',
        'tong_store': '购买时可选最大通店数',
        'support_store_type': '请选择支持门店类型',
        'pay_methods': '请选择消费方式',
        'if_experience': '请选择是否为体验卡',
        'has_store_type': '支持门店类型不能为空',
        'time': '请选择时间',
        'cycle': '请选择周期～',
        'enter_times':'限制入场时间不能空～',
        'stop_card': '请选择停卡日期',
        'choose': '选择',
        'one': '个',
        'start_time': '请选择开始日期 ~ ~',
        'coach_one': '请先选择一个教练~~',
        'locker_charge': '请选择需要收取押金的租赁柜合同~~',
        'coach': '请选择上课教练',
        'lesson': '请选择课程',
        'contract_end': '请选择合同结束日期',
        'caninet': '请选择租赁柜',
        'Member': '已选用户',
        'transfer_contract': '请选择待转让合同~~',
        'dai': '选择预约的课程',
        'appoint_card': '选择预约使用的卡',
        'no_contract': '暂无有效的合同可供选择',
    },
    'Charge': {
        'title1': '定金收取',
        'deposit_amount': '定金金额',
        'expiration_date': '过期日',
        'use_date': '使用日期',
        'use_contract_type': '使用合同类型',
        'use_contract_number': '使用合同编号',
        'search': '本次搜索',
        'search2': '本次搜索共',
        'all': '共',
        'count': '个合同',
        'total_deposit': '支付成功后定金总额',
        'total_existing_deposit': '现有定金总额',
        'base_amt': '基础金额',
        'discounted_price': '优惠金额',
        'finally_money': '最终结算金额',
        'contract_deduction': '定金合同抵扣',
        'amount_to_be_paid': '待支付金额',
        'paid': '待支付金额',
        'amount_receivable': '应收金额',
        'team': '支持付费团课',
        'discount': '优惠金额（元）',
        'choose_type': '选择押金类型',
        'member_card': '会员卡押金',
        'locker': '租赁柜押金',
        'choose_locker': '选择需要收取押金的租赁柜合同',
        'no_locker': '会员暂时没有租赁柜合同',
        'money': '收取押金',
        'amount_paid': '已付金额',
        'be_paid': '待付金额',
    },
    'Sell': {
        'title1': '会籍合同管理',
        'title2': '私教合同管理',
        'personal': '私教合同',
        'title3': '租赁柜合同管理',
        'title4': '储值卡合同管理',
        'title5': '定金合同',
        'title6': '押金管理',
        'title7': '会籍卡设置',
        'title8': '储值卡设置',
        'title9': '合同设置',
        'title10': '卡号设置',
        'all_saler': '所有会籍销售',
        'allsaler': '所有销售',
        'all_status': '所有状态',
        'all_yajin': '全部押金类型',
        'yajin_type': '押金类型',
        'all_ya_type': '全部押金状态',
        'yajin_status': '押金状态',
        'yajin_money': '押金金额',
        'sell_status': '所有售卖状态',
        'ban': '禁售',
        'search_card': '搜索客户卡种编号,卡名称',
        'search_card2': '卡种编号,卡名称',
        'bang': '已绑定',
        'discard': '废弃',
        'search_client': '搜索客户姓名、电话、合同号、会员卡号',
        'he_print': '合同打印预览',
        'small_print': '小票打印预览',
        'pay': '收银',
        'refund': '押金退款',
        'refund2': '退款',
        'more': '更多',
        'upgrade': '升级',
        'freeze': '冻结',
        'cancel_freeze': '取消冻结',
        'frozen_or_not': '是否冻结中',
        'transfer': '转让',
        'bu_card': '补卡',
        'gift': '赠送',
        'change_number': '修改合同编号',
        'change_coach': '修改上课教练',
        'change_validity': '修改合同有效期',
        'change_ci': '修改剩余次数',
        'change_lesson': '修改剩余课时',
        'chang_time': '批量修改合同开始时间',
        'change_store': '批量修改支持门店',
        'demolition': '业绩拆分',
        'remark': '对内备注',
        'operation_record': '操作记录',
        'limi_enter': '限制入场',
        'old_number': '原合同编号',
        'new_number': '新合同编号',
        'edit_remark': '编辑对内备注',
        'sign_date': '签约日期',
        'charge_date': '收款日期',
        'sell_date': '售卖日期',
        'add_card_time': '添加持卡入场时间',
        'limi_enter_time': '限制持卡入场时间',
        'identity_number': '身份证号',
        'Pay': {
            'title': '支付方式',
            'cash': '现金',
            'swipe': '刷卡',
            'bank': '银行转帐',
            'alipay': '支付宝(门店)',
            'wechat': '微信(门店)',
            'other': '其他',
            'all': '消费总额',
            'money': '常规售价',
            'money2': '常规售价（元/节）',
            'fee': '手续费（元）',
            'people': '收款人',
            'methods': '请选择支付方式',
            'methods2': '支持消费方式',
            'consumption': '消费',
            'amounts_payable': '应付金额',
            'buy': '购买',
        },
        'Charge': {
            'ya': '押金收取',
            'paid_amount': '实收金额',
            'ding': '收取定金',
            'vi_date': '请输入有效的有效期天数',
            'vi_money': '请输入有效的定金金额',
            'base_amt': '基础价格',
            'history': '合同变更历史',
            'charge': '变更',
            'money': '储值金额',
            'current_balance': '当前余额',
        },
        'standard_amount': '标准金额',
        'sell_store': '售卖门店',
        'store': '可售卖门店',
        'Time': {
            'sell': '售卖时间',
            'start': '请选择起始日期',
        },
        'saler': '全部销售人',
        'pay_methods': '全部支付方式',
        'Print': {
            'memberName': '会员姓名：',
            'gender': '性别：',
            'phone': '手机：',
            'ID_number': '身份证号：',
            'Home_Address': '家庭住址：',
            'discounts': '优惠',
            'receivable': '应收',
            'Number_of_classes': '购课节数',
            'Lease_cabinet_area': '租赁柜区域',
            'Amount_of_value': '储值金额',
            'contract_life': '合同有效期：',
            'Total_Deposit_Payment': '支付定金合计',
            'Total_amount_paid': '支付金额合计',
            'Member_signature': '会员签名',
            'Club_Constitution': '会所章程',
        },
        'Show': {
            'client_phone': '客户手机号',
            'referrerID':'推荐人ID',
            'referrerName': '推荐人姓名',
            'Contract_Sales_StaffID': '合同销售员工ID',
            'Contract_Sales_StaffName': '合同销售员工昵称',
            'Customer_membership_card': '客户当前会员卡号',
            'Customer_membership_storeID': '客户当前会员卡号所属门店ID',
            'Pending_binding_card': '待绑定客户会员卡号',
            'Pending_binding_shop': '待绑定客户会员卡号所属门店ID',
            'Open_Card_Store_ID': '开卡门店ID',
            'Name_of_Open_Card_Store': '开卡门店名称',
            'Membership_card_quota': '会籍卡额度',
            'Credit_of_Membership_Card': '会籍卡剩余额度',
            'Contract_notes': '合同备注',
        },
        'TicketPrint': {
            'statement': '结账单',
            'type': '类型',
            'entry_name': '项目名称',
            'unitprice': '单价',
            'subtotal': '小计',
            'refund_amount': '退款金额',
            'Actual_receipt_details': '实收明细',
            'Refund_details': '退款明细',
            'merchant': '商家',
        },
        'Dialog': {
            'add_time': '添加时间',
            'info_change': '信息变更',
            'set_price': '批量设置价格',
            'split': '合同业绩拆分',
            'main_saler': '主要售卖人',
            'assist_saler': '协助售卖人',
            'modify_btn': '确定修改',
            'chang_time': '修改合同开始时间',
            'choosed_contract': '已选合同',
            'filter_total': '已选现有筛选条件下全部',
            'start_time': '合同开始时间修改为',
            'tip': '注：第一次入场开卡的合同，若会员未入场将不做合同开始时间的修改',
            'old_validity': '原合同有效期',
            'change_into': '修改为',
            'tip2': '该合同为第一次入场开卡，不允许修改有效期~~',
            'refund_method': '退款方式',
            'new_member_card': '新会员卡号',
            'tranfer': '转让给',
        },
        'Buy': {
            'single_buy': '单次购买私教课程设置',
            'support': '是否支持单次购买私教课程设置：支持',
            'support_personal': '支持付费私教课程',
        },
        'Refund': {
            'option1': '仅退款(仅支持有效合同)',
            'option2': '客户要求终止合同（此合同变为无效，例如退会、退课、退柜、退储值卡）',
            'option3': '合同信息录入错误，退款重办（此合同将变为无效）',
            'option4': '押金正常归还',
            'option5': '信息录入错误，退款重办',
            'tip': '退款金额不能超过实付金额~~',
            'success': '退款操作成功!!',
        },
        'OutstandingAmount': '尚欠金额',
        'Unlike_followup_sales': '与跟进销售不同',
        'Selling_status': '售卖状态',
        'StoreList': '可售卖门店列表',
        'Admission_list': '可入场门店列表',
        'AdmissionStore': '可入场门店',
        'Restriction_of_time': '限制入场时段',
        'Basic_sell_price': '基础售卖价格',
        'Operation_content': '操作内容',
        'Validity_period(days)': '有效期(天)',
        'freeze_date': '冻结日期',
    },
    'Contract': {
        'Desc': {
            'contentLabel': '合同正文',
            'settingsLabel': '合同设置',
            'current_remaining': '当前剩余',
            'title': '合同标题',
            'hide': '不显示',
            'show': '显示',
            'default_show': '默认显示标题',
            'default': '默认',
            'customize_show': '显示自定义标题',
            'customize': '自定义',
            'logo': '左上角logo',
            'charter': '合同章程',
            'deposit': '定金合同条款',
            'member': '会员签名及签订日期',
            'club_sign': '会所签名及签订日期',
            'top': '第一行距顶部高度',
            'zoom': '缩放',
            'amount': '额度',
            'old_number': '原合同号',
            'date_of_signing': '签订日期',
            'number': '序号',
            'subscribeWay': '预约方式',
            'lablecontent': '标签内容',
        },
        'Transfer': {
            'member': '会籍合同转让',
            'personal': '私教合同转让',
            'locker': '租赁柜合同转让',
            'cards': '储值卡合同转让',
        },
        'effective': '有效合同',
        'start_time': '合同开始日期',
        'end_time': '合同结束日期',
        'tips': '除此之外其余私教合同自动顺延天数=剩余课数*7天*',
        'tip2': '自定义系数',
        'card_name': '卡种名称',
        'support_store': '支持门店',
        'desc': '合同详情',
        'id': '合同ID',
        'number': '合同编号',
        'status': '合同状态',
        'card_hao': '卡号',
        'validity_period': '合同有效期',
        'freeze': '合同冻结',
        'charge_date': '收款日',
        'up': '升级合同',
        'start_end_date': '合同起止日期',
        'start_date': '请选择合同开始日期',
        'fill_number': '请输入合同编号',
        'all_type': '全部合同类型',
        'operation_types': '全部操作类型',
        'number2': '合同号',
        'type': '合同类型',
    },
    'Staff': {
        'Modify': {
            'administrator': '修改超管手机',
            'old': '超管原手机号',
            'code':  '验证码',
            'password': '登录密码',
            'new': '超管新手机号',
            'fill_new': '请输入新手机号(登录账号)',
            'handle_code': '获取验证码',
            'again': '重新获取',
            'refresh': '秒后重发',
            'code_success': '验证码发送成功',
            'correct': '请填写正确的手机号',
            'success': '修改成功，请重新登录',
            'change_new': '更改超管账号为新手机号',
        },
        'Employee_details': '员工个人详情',
        'list': '员工列表',
        'placeholder_search': '员工工号、姓名、手机号',
        'job_number': '工号',
        'job_number_placeholder': '请填写工号',
        'nickname': '昵称',
        'login_count': '登录账号',
        'password': '密码',
        'actual_name': '真实姓名',
        'store_range': '门店范围',
        'single_store': '单店',
        'national': '全国',
        'tong_store': '通店',
        'all_store': '全店',
        'attend': '设置员工可上课程',
        'take_team': '可上团课',
        'take_personal': '可上私教课',
        'Incumbency': '在职状态',
        'be_on_the_job': '在职',
        'practice': '实习',
        'part-timejob': '兼职',
        'dimission': '离职',
        'Job_selection': '职位筛选',
        'All_States': '全部状态',
        'date_on_board': '入职日期',
        'New_employees': '新增员工',
        'role': '角色',
        'Employee_Rights_Manage': '员工权限管理',
        'Confirm_del_employee': '确认删除这个员工',
        'Confirm_recover_employee': '确认恢复这个员工',
        'Employee_details': '员工详情',
        'synopsis': '简介',
        'Employee_photo': '员工相册',
        'Show_style_coach': '显示在会员端教练风采',
        'entry_time': '入职时间',
        'resignation_time': '离职时间',
        'Staff_rank': '员工等级',
        'Bank_card_number': '银行卡号',
        'opening_bank': '开户行',
        'current_residence': '现居住地',
        'school_graduation': '毕业学校',
        'major': '专业',
        'GraduationDate': '毕业时间',
        'education': '学历',
        'nativeplace': '籍贯',
        'First_level_module': '一级模块',
        'two_level_module': '二级模块',
        'Jurisdiction': '权限',
        'Successful_role_del': '删除角色成功',
        'delete_role': '确定删除此角色吗？',
    },
    'Stats': {
        'Updatereport': '更新报表',
        'Member_profile': '会员概况',
        'Revenue_daily': '营收日报',
        'Revenue_streams': '营收流水',
        'Revenue': {
            'today_total': '今日总营收',
            'member': '今日会籍合同营收',
            'personal': '今日私教合同营收',
            'locker': '今日租赁柜合同营收',
            'card': '今日储值卡营收',
            'charge': '今日定金营收',
            'charge2': '今日押金营收',
            'stop': '今日停转补营收',
            'day_up': '日新增',
            'total': '总累计',
            'member_contract': '会籍合同总额',
            'income': '收入',
            'out': '支出',
            'net_revenue': '净营收',
            'personal_con': '私教合同总额',
            'locker_con': '租赁柜合同总额',
            'card_con': '储值卡合同总额',
            'total_deposit': '定金总额',
            'total_charge': '押金总额',
            'total_stop': '停转补',
            'revenue': '营收额',
            'all': '总量',
            'total_revenue': '总营收',
        },
        'Time': {
            'yesterday': '昨日',
            'this_week': '本周',
            'this_month': '本月',
            'seven': '近7天',
            'half_month': '近15天',
            'a_month': '近30天',
        },
        'Enter': {
            'people': '今日入场人数',
            'personal_sign': '今日私教签到节数',
            'team_people': '今日团课上课节数',
            'team_appoint': '今日团课预约人数',
            'person_lesson': '私教上课',
            'team_lesson': '团课上课',
            'lesson': '上课节数',
            'all_appoint': '总预约人数',
            'all_sign': '总签到人数',
            'sign': '签到人数',
        },
        'Search': {
            'type': '按类型查询',
            'pay_method': '按支付方式查询',
            'staff': '按员工维度',
            'lesson': '按课时维度',
        },
        'Card': {
            'member': '会籍合同',
            'personal': '私教合同营收',
            'locker': '租赁柜合同',
            'value_card': '储值卡合同',
            'charge': '押金',
        },
        'Balanc': {
            'opera': '平账操作',
            'amt': '平账金额',
            'choose_amt': '请选择平账金额',
            'confirm_add': '确定添加',
            'fill_amt': '请输入合法的平账金额',
            'required': '平账备注为必填项',
        },
        'Update': {
            'title': '更新',
            'table': '报表',
            'store': '更新门店',
            'time': '更新时间',
            'confirm': '确定更新',
            'ps': '注：选择时间越长，更新等待时间将越久',
            'message': '提交更新任务成功，请等待更新~~',
        },
    },
    'Coach': {
        'all_team': '全部团课教练',
        'name_team': '团课教练姓名',
        'name_personal': '私教姓名',
        'level': '教练级别',
        'charge_lesson': '收费课',
        'one': '一级课',
        'two': '二级课',
        'three': '三级课',
        'four': '四级课',
        'fifth': '五级课',
        'lesson_all': '课小计',
        'free': '免费课',
        'take_time': '可约时间',
        'choose_time': '选择时间',
        'add_appoint_time': '添加可预约时间',
        'add_leave_time': '添加请假时间',
        'start_time': '请选择开始时间！',
        'end_time': '请选择结束时间！',
        'check': '点击查看',
        'no_permission': '没有添加或者修改的权限~~',
    },
    'Role': {
        'edit': '编辑角色',
        'add': '添加角色',
        'name': '角色名称[中]',
        'name2': '角色名称[英]',
        'fill_name': '请输入角色名称',
        'is_copy': '从现有角色复制',
        'no_copy': '不复制',
        'edit_success': '编辑角色成功',
        'add_success': '新建角色成功',
    },
    'Setting': {
        'tag': '修改标签',
        'Brand_setup': '品牌设置' ,
        'Store_information': '门店信息',
        'other_setting': '其他设置',
        'Import_record': '导入记录',
        'Export_record': '导出记录',
        'all': '全部',
        'export_con': '导出内容',
        'export_state': '导出状态',
        'DownloadReport': '下载报表',
        'export_data': '导出数据',
        'import_con': '导入内容',
        'import_state': '导入状态',
        'Update_data': '更新数据',
        'err_data': '错误数据',
        'new_data': '新增数据',
        'download_errReport': '下载错误报告',
        'allnews': '全部消息',
        'readed': '标记已读',
        'system': '系统',
        'order': '预约',
        'common_setting': '通用设置',
        'SortDisplayWeight': '排序显示权重',
        'Tag': {
            'name': '标签名称',
            'fill_name': '请输入标签名称',
            'edit_success': '修改客户标签成功',
            'add_success': '新增客户标签成功',
        },
        'message': '消息详情',
        'Message': {
            'title': '标题',
        },
        'content': '内容',
        'notice': '发送系统公告',
        'send': '发送',
        'Notice': {
            'fill_title': '请输入标题',
            'fill_content': '请输入内容',
        },
        'Integral': {
            'title': '积分设置',
            'base_set': '基本设置',
            'single': '单次消费送积分:',
            'full': '消费满',
            'give': '送',
            'limi': '每日获取积分上限：',
            'on': '启用',
            'off': '不启用',
        },
    },
    'Finance': {
        'Bank': {
            'money': '提现',
            'open': '开户银行',
            'choose_open': '请选择开户银行',
            'city': '开户城市',
            'shi': '市',
            'qu': '区',
            'name': '支行名称',
            'name_as': '请输入银行支行名称，如 田林路支行',
            'client_name': '银行开户名',
            'client_as': '范例：上海森融网络科技有限公司 or  张三丰',
            'account': '银行账号',
            'fill_account': '请输入银行账号',
            'mybankcard': '我的银行卡',
            'ConstructionBank': '建设银行（上海徐汇淮海支行）',
            'TwoDimensionalCode': '门店支付二维码',
        },
        'money': '提现金额',
        'fill_money': '请输入提现金额',
        'Balance_manage': '余额管理',
        'Wage_template': '工资模版',
        'Withdrawable': '可提现金额',
        'ForPCPayment': '(仅用于云小店PC支付)',
        'dealtime': '处理时间',
        'Settling_time': '结算时间',
        'alltype': '所有类型',
        'addnewtemplate': '添加新模版',
        'templatename': '模版名称',
        'templatetype': '模版类型',
        'Settlement_of_Hours': '按固定值结算课时费',
        'percentage': '按上课总课程价值百分比结算',
        'Monthly_salary': '月底薪',
        'Monthly_sales': '月销售额',
        'including': '万（含）至',
        'excluding': '万（不含），提成',
        'Monthly_attendance': '月上课数',
        'Section_(including)_to': '节（含）至',
        'SectionNo': '节（不含），课时/节',
        'Adding_gradient': '添加梯度',
        'enter_template_name': '请输入模版名称',
        'enterMonthlysalary': '请输入月底薪',
        'mustnumber': '月底薪须为数字值',
        'Monthly_fixed': '月固定底薪',
        'Monthly_sales': '月销售额提成',
        'SettingHours': '按月销售额设定课时费',
        'SettingClasses': '按月上课数设定课时费',
    },
    'Store': {
        'Contract': {
            'New_ContractNumber': '新增合同编号',
            'digit': '位数',
            'Ruledescription': '规则描述',
            'fixation': '固定',
            'char_format': '字符格式',
            'Fixed_character': '固定字符时选中的字符',
            'FixedCharacters': '是否固定字符',
            'num0_9': '数字(0-9)',
            'Letter(A-Z)': '字母(A-Z)',
            'Sel_numbers_letters': '选择数字或字母',
            'Please_choose': '请选择是否固定字符',
            'Char_empty': '字符格式不能为空',
            'CustomNumber': '启用自定义合同编号',
            'no_CustomNumber': '不启用自定义合同编号',
        },
        'Edit': {
            'store_name': '门店名称',
            'store_code': '门店代码',
            'store_phone': '门店电话',
            'select_province': '请选择省份',
            'select_city': '请选择城市',
            'select_area': '请选择地区',
            'Adjust_location': '调整定位',
            'import_keyword': '请输入关键字：',
            'store_longitude': '门店所在经度',
            'store_latitude': '门店所在纬度',
            'email': '邮箱',
            'rank_weight': '排序权重',
            'operation_not': '是否试运营',
            'Storename_not_empty': '门店名称不能为空',
            'phone_not_empty': '电话号码不能为空',
            'Provinces_not_empty': '省份不能为空',
            'city_not_empty': '城市不能为空',
            'place_not_empty': '地区不能为空',
            'add_not_empty': '地址不能为空',
            'Latitude_not_empty': '纬度不能为空',
            'longitude_not_empty': '经度不能为空',
            'email_not_empty': '邮箱不能为空',
            'Sortweight_not_empty': '排序权重不能为空',
            'Sortweight_number': '排序权重须为数字值',
            'trialoperations': '是否试运营不能为空',
        },
        'Place': {
            'placename': '场地名称',
            'galleryful': '可容纳人数',
            'state_normal': '状态是否正常',
            'recover_place': '恢复场地',
            'storeplace_not_empty': '门店场地名称不能为空',
            'No_empty_accommodate': '可容纳人数不能为空',
            'Confirm_del_information': '确认删除这条场地信息?',
            'Confirm_recover_place': '确认恢复这个场地?'
        },
        'enter_name_store': '请输入门店名称',
        'enter_code_store': '请输入门店代码',
        'enter_phone_store': '请输入门店电话',
        'storeaddrs': '门店地址',
        'enter_storeaddrs': '请输入门店地址',
        'store_state': '门店状态',
        'new_store': '新增门店',
        'CustomContractNumber': '自定义合同编号',
        'site_management': '场地管理',
        'Restore_stores': '恢复门店',
        'Trial_operation': '试运营状态门店',
    },
    'Other': {
        'have_no_effect': '没有效果',
        'login': {
            'accountNumber': '请输入账号',
            'Password': '请输入密码',
            'Landing': '登陆中...',
            'Land': '登 陆',
            'account_password_err': '账号密码错误！',
        },
        'MyProfile': {
            'change_password': '密码修改',
            'originalpassword': '原密码',
            'newpassword': '新密码',
            'import_newpass': '请输入新密码',
            'not_six_newpass': '请输入不少于6位的新密码！',
            'import_originalpassword': '请输入原密码',
        },
        'Print': {
            'storeName': '门店名',
            'printtime': '打印时间',
            'member_sign': '会员签字',
            'coach_sign': '教练签字',
            'reception_sign': '前台签字',
        },
        'Upload': {
            'download_template': '下载模板',
            'deal_data': '数据处理方式',
            'upload_files': '上传文件',
            'firststep': '第一步',
            'please_click': '请点击右侧按钮下载模版文件，按格式填写好信息后再进行导入',
            'tolead_info': '导入信息如下图所示',
            'red_info': '红色信息',
            'required_fields': '为必填项',
            'announcements': '注意事项',
            'client_realname': '填写客户的真实姓名',
            'man_or_wom': '男或女',
            'eleven': '11位数字',
            'such_as': '例如',
            'deleted_user_not_allowed': '已删除用户不可进出俱乐部',
            'followup_sales': '跟进销售',
            'followup_sales_niname': '跟进销售昵称',
            'niname_inlist': '销售昵称在员工列表里',
            'flowup_coach_nickname': '跟进私教教练昵称',
            'coach_inlist': '私教教练昵称在员工列表里',
            'Member_card': '会籍卡号',
            'Member_number': '会籍卡编号',
            'ifyou_holdmembership ': '若为正式会员持有会员卡则填写会员卡号',
            'must_import_cardshop': '若填写了会籍卡号则门店必填',
            'member_card_shop': '会员卡号的发放门店',
            'year4mon2day2': '年四位月两位日两位',
            'or': '或者',
            'some_other': '外出获取/自有网络/大众点评/美团/其他第三方平台/直接到访(WI)/朋友转介绍(BR)/拉访(DI)/电话咨询(TI)/其他',
            'manpower_ohter': '人力推广/广告/公司网络/市场活动/其他',
            'Various_syndromes': '身份证/护照/学生证/老年证/业主证',
            'import_ID_Number': '填写证件号码',
            'Non_essential_items': '非必填项',
            'Membership_number': '会籍合同编号',
            '11_phone_number': '11位会员手机号码',
            'SystemSetting': '系统设置的会员卡名称',
            'buys_num': '购买次数（若会籍卡为次卡则为必填）',
            'Number_of_purchases': '购买时的次数',
            'Remainingtimes': '剩余次数（若会籍卡为次卡则为必填）',
            'ResidualCard': '当前剩余次卡',
            'remark_transaction': '新办、续办、转让（例：A合同被转让生成新合同B，导入时A合同类型为新办，合同截止日期为被转让日期，B合同类型为转让',
            'Original_cont_number': '原合同号（若合同类型为转让则为必填）',
            'Write_the_original': '若为转让则写原合同号',
            'Isit_effective': '有效、无效（无效是指已退费的合同）',
            'originalprice': '原价格',
            'The_amount_becharged': '应该收取的金额，区别于实收金额（大于等于实收金额）',
            'The_actual_amount': '实际收取金额，区别于应收金额（小于等于应收金额）',
            'Transfer_accounts': '现金、刷卡、银行转账',
            'if_any_import': '时分秒如果有可以填',
            'Open_card_day': '当天买卡当天开卡、第一次入场开卡（若会员已入场，请将入场日期填写在合同开始日期内）、指定日期开卡',
            'Days_of_validity': '合同有效天数（若开卡方式为“第一次入场开卡”则为必填）：合同有效的天数',
            'salesperson_niname': '填写销售人（员工）昵称',
            'Shops_that_open': '填写签约合同即开卡、续会的门店',
            'Shops_supported': '填写该合同支持的门店（多门店用逗号分隔）',
            'PrivateEducation_num': '私教合同编号',
            'CourseSetup': '系统设置的私教课程名称',
            'level_of_courses': '课程级别',
            'personlevel': '私教课程设置的级别',
            'Number_of_courses': '购买时的课程数',
            'importclassnum': '购买数量填写（若会籍卡为次卡则为必填）',
            'current_remaining': '当前剩余填写（若会籍卡为次卡则为必填）：购买的课程剩余课时数',
            'ContractType': '合同类型填写',
            'other_formalities_eg': '新办、续办、转让（例：A合同被转让生成新合同B，导入时A合同类型为新办，合同截止日期为被转让日期，B合同类型为转让）',
            'write_niname': '填写上课教练（员工）昵称',
            'write_shop': '填写签约合同的门店',
            'cabinet_located': '填写签约合同即租赁柜所在门店',
            'StorageCard': '储值卡合同编号',
            'CardName': '储值卡名称',
            'SystemCardName': '系统设置的储值卡名称',
            'storage_value': '储值金额',
            'buy_at_time_mon': '购买时的金额',
            'remaining_amount': '当前剩余金额',
            'longinfo': '新办、转让（例：A合同被转让生成新合同B，导入时A合同类型为新办，合同截止日期为被转让日期，B合同类型为转让）',
            'Lease_cabi_cont_num': '租赁柜合同编号',
            'initials+lease': '自定义的租赁柜号（首字母+租赁柜编号）',
            'Fillin_ContractType': '合同类型填写',
            'leaseperiod': '租赁柜租期（单位：月)',
            'somepact': '有效、无效（无效是指被转让的原合同或退费合同）',
            'Actual_amountcharged': '实际收取金额',
            'handle_cliet_card': '给客户办理此卡的门店',
            'second_step': '第二步',
            'Choos_way': '选择数据重复时的操作方式',
            'import_new_data': '导入新数据并覆盖更新重复数据',
            'New_additions': '针对不重复的数据进行新增',
            'theday_buy': '当天买卡当天开卡、指定日期开卡',
            'updates_for_duplicate_data': '针对重复的数据进行覆盖更新',
            'recoverdata': '针对重复的数据不进行覆盖更新，保留原始数据',
            'only_import': '仅导入新数据，不覆盖更新重复数据',
            'dont_import': '不导入新数据，仅覆盖更新重复数据',
            'new_data_import': '针对不重复的数据不进行新增',
            'importeleven': '导入未填写手机号，随机匹配11位数字',
            'thri_step': '第三步',
            'pleafileupload': '请上传文件',
            'UploadImport': '上传导入',
            'choose_data_process_way': '请选择数据处理方式！',
            'only_new_recinfo': '仅针对重复的数据进行覆盖更新',
            'buycard_indate': '当天买卡当天开卡和指定日期开卡时必填（若此合同已被转让，请填写合同被转让日期）',
            'or': '或',
            'the_daycard_mustwrite': '当天买卡当天开卡和指定日期开卡时必填，如果是第一次入场开卡，若已入场则必填',
        },
        'DragUpload': {
            'drag_and_drop': '请将文件拖拽至此处',
            'fliename': ' 文件名称',
            'fliesize': '文件大小',
        },
    },
    'Login': {
        'tip': '此忘记密码流程仅适用于超管帐号，普通员工若忘记密码，请咨询店长或超管进行重置',
        'forgot': '忘记密码',
        'phone': '请输入需要找回的手机号',
        'kaptchaCode': '请输入右侧图形校验码',
        'password': '请输入不少于6个字符的密码',
        'confirm': '确认',
        'message': '修改成功，请登录',
    },
    'Measurement': {
        'Basalmetabolism': '基础代谢',
        'Fatweight': '脂肪重量',
        'Bodymeasuretime': '体测时间',
        'height': '身高',
        'fatcontent': '脂肪含量',
        'details': '详情',
        'MembershipInformation': '会员体测信息',
        'Body_fat_percentage': '体脂率',
        'Skeletal_muscle_content': '骨骼肌含量',
        'Bust': '胸围',
        'Thewaist': '腰围',
        'Hipline': '臀围',
        'L_Hipline': '大臂围（L）',
        'R_Hipline': '大臂围（R）',
        'L_Thighcircumference': '大腿围（L)',
        'R_Thighcircumference': '大腿围（R)',
        'Phototaking': '体测拍照',
    },
    'System': {
        'title': '切换语言',
        'cn': '中文',
        'en': '英文',
        'sure': '确认切换语言',
    },
};
